module.exports = __webpack_public_path__ + "static/product.ysjs-539768f6910a2b72f9557d4657335d4e.png";